export default __webpack_public_path__ + "static/media/img_pdf-5.481f8e1a.png";